module.exports = __webpack_public_path__ + "static/media/vampire.139947b8.jpg";